import React from 'react'
import { SearchOutlined } from '@ant-design/icons'
import { Col, Divider, Form, Input, InputNumber, Row, Spin, Switch } from 'antd'
import container from './container'

const HotelEditor = props => {
    const { catalogs, shownColumns, filter, setFilter, $form, $props, $loading, $fieldProps, isEditMode } = props

    return (
        <Spin spinning={$loading}>
            <Form {...$props} colon={false} layout={'vertical'} wrapperCol={{ flex: 1 }}>
                {$form.Item({ name: 'mode' })}
                <Row gutter={16}>
                    <Col xs={24} md={8}>
                        <Form.Item name={'hotel_id'} label={'Hotel ID'} {...$fieldProps.hotel_id}>
                            <Input disabled={isEditMode} placeholder={'2151861'} />
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={4}>
                        <Form.Item name={'country_code'} label={'Country'} {...$fieldProps.country_code}>
                            <Input maxLength={2} placeholder={'VN'} />
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={4}>
                        <Form.Item name={'timezone'} label={'Timezone'}>
                            <Input placeholder={'+07:00'} />
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={4}>
                        <Form.Item name={'rank'} label={'Rank'}>
                            <InputNumber precision={0} style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={4}>
                        <Form.Item name={'is_active'} label={'Active'} {...$fieldProps.is_active}>
                            <Switch />
                        </Form.Item>
                    </Col>
                </Row>
                {isEditMode ? null : (
                    <Form.Item
                        name={'regions'}
                        label={'Regions (EPS)'}
                        extra={'region_ids separated by commas or spaces; each must exist in lst_region.'}>
                        <Input.TextArea rows={2} placeholder={'3023, 6054439'} />
                    </Form.Item>
                )}
                <Divider orientation="left">Supplier catalogs</Divider>
                <Input
                    allowClear
                    prefix={<SearchOutlined />}
                    placeholder={'Filter by column or supplier code'}
                    value={filter}
                    onChange={e => setFilter(e.target.value)}
                />
                <br />
                <br />
                <Row gutter={16}>
                    {catalogs.map(catalog => (
                        // Filtered-out inputs stay mounted so their values are still submitted.
                        <Col
                            key={catalog.column}
                            xs={24}
                            md={8}
                            style={shownColumns[catalog.column] ? undefined : { display: 'none' }}>
                            <Form.Item
                                name={['suppliers', catalog.column]}
                                label={catalog.column}
                                extra={catalog.codes.join(', ')}>
                                <Input allowClear placeholder={'not mapped'} />
                            </Form.Item>
                        </Col>
                    ))}
                </Row>
            </Form>
        </Spin>
    )
}

export default container(HotelEditor)
